import(/* webpackMode: "eager" */ "/codebuild/output/src2681306950/src/kenshoku-bank/nextjs/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["PcJobDetail"] */ "/codebuild/output/src2681306950/src/kenshoku-bank/nextjs/src/components/jobs/pc-job-detail.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpJobDetail"] */ "/codebuild/output/src2681306950/src/kenshoku-bank/nextjs/src/components/jobs/sp-job-detail.tsx");
